import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { FormValue } from '../../../entities/form-value.entity';
import { ShFormTimeComplexBaseComponent } from '../base-complex/form-time-complex-base.component';
import { AsyncPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'sh-form-time-base',
    templateUrl: '../base-complex/form-time-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormTimeBaseComponent)],
    standalone: true,
    imports: [ReactiveFormsModule, AsyncPipe]
})
export class ShFormTimeBaseComponent extends ShFormTimeComplexBaseComponent {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    propagateChange(fv: FormValue<string>): void {
        super.propagateSimpleChange(FormValue.unwrap(fv));
    }

    writeValue(obj: any): void {
        super.writeValue(FormValue.wrap(obj));
    }
}
